export const FirName = 'FirstImportantRendering';
export const StartFir = `${FirName}-start`;
export const FinishFir = `${FirName}-finish`;

export enum PerformanceMeasurementName {
    Fir = 'perf.fir',
    Tti = 'perf.tti',
    LargestContentfulPaint = 'largest-contentful-paint',
    RumHeight = 'per.rum.innerHeight',
    RumWidth = 'per.rum.innerWidth',
    RumFinRenderAbs = 'PER.RUM.FIN_RENDER.ABS',
    CriticalFinish = 'critical.finish',
}
